import * as React from "react";
import { FileText, UserPlus, Video } from "lucide-react";
import { Link } from "@/components/common/Link";
import { Button } from "@/components/ui/button";
import { Card, CardContent, CardDescription, CardFooter, CardHeader, CardTitle } from "@/components/ui/card";
const resourcesData = [{
  title: "Download Forms",
  description: "Complete your essential medical history and registration forms online to ensure a seamless check-in experience.",
  icon: FileText,
  buttonText: "Download Now",
  link: "/YourJourneyPage"
}, {
  title: "Your Checklist",
  description: "Review our comprehensive pre-operative guide to prepare your home and body for a successful surgical recovery.",
  icon: UserPlus,
  buttonText: "View Checklist",
  link: "/YourJourneyPage"
}, {
  title: "Telehealth Prep",
  description: "Access step-by-step instructions for connecting with our neurosurgical team via our secure virtual platform.",
  icon: Video,
  buttonText: "Get Started",
  link: "/ConnectPage"
}];
export default function PatientResources() {
  return <section data-section-id="88577" id="prepare-for-your-visit" className="bg-background py-16 md:py-24">
      <div className="container mx-auto max-w-screen-xl px-4 md:px-8">
        <div className="mb-12 text-center">
          <h2 className="font-sans text-3xl font-bold tracking-tight text-primary md:text-4xl">
            Prepare for Your Visit
          </h2>
          <p className="mt-4 font-sans text-lg text-muted-foreground">
            We treat every patient like family. Access the resources you need for a smooth journey.
          </p>
        </div>

        <div className="grid grid-cols-1 gap-6 md:grid-cols-3 md:gap-8">
          {resourcesData.map((resource, index) => {
          const Icon = resource.icon;
          return <Card key={index} data-index={index} className="group flex h-full flex-col border-border bg-card/60 backdrop-blur-md rounded-xl transition-all duration-300 hover:-translate-y-2 hover:shadow-lg">
                <CardHeader className="pb-4">
                  <div className="mb-4 inline-flex h-16 w-16 items-center justify-center rounded-2xl bg-secondary/10 text-secondary transition-colors group-hover:bg-secondary group-hover:text-primary-foreground">
                    <Icon className="h-8 w-8" strokeWidth={1.5} />
                  </div>
                  <CardTitle className="font-serif text-2xl italic text-foreground">
                    {resource.title}
                  </CardTitle>
                </CardHeader>
                <CardContent className="flex-grow pb-6">
                  <CardDescription className="line-clamp-2 font-sans text-base text-muted-foreground leading-relaxed">
                    {resource.description}
                  </CardDescription>
                </CardContent>
                <CardFooter className="pt-0">
                  <Button asChild variant="outline" className="w-full rounded-full border-2 border-secondary bg-transparent text-secondary transition-all duration-300 hover:bg-secondary hover:text-white hover:scale-[1.02]">
                    <Link to={resource.link}>{resource.buttonText}</Link>
                  </Button>
                </CardFooter>
              </Card>;
        })}
        </div>
      </div>
    </section>;
}